import { RenderMediaContent } from "src/components/RenderMediaContent";
import ipconfig_settings from '../../assets/setup/ipconfig.png';
import connect_desktop from '../../assets/setup/tutorial_connect_desktop.png';
import { WarningAlert } from "src/components/WarningAlert";

export const InitialSetup: React.FC = () => {
    return (
        <div className="flex flex-col justify-center gap-y-4 px-4">
            <p>Please ensure your SAMMI is updated to the latest version, as some features may not work on older versions.</p>
            <div className="flex flex-col">
                <h2 className="text-xl font-bold">Download Deck Hopper</h2>
                <a href="/deckhopper/download" className="text-blue-500 underline">
                    Click here to download Deck Hopper
                </a>
            </div>

            <WarningAlert message="If you're on Linux, ensure you have fuse installed: <code>sudo apt-get install fuse -y</code>" />

            {/* Connection Setup Instructions */}

            <h2 className="text-xl font-bold">Connection Setup</h2>
            <div className="flex flex-col gap-y-4">
                <RenderMediaContent src={connect_desktop} />

                <table className="table-auto w-full text-left">
                    <thead>
                        <tr className="bg-transparent">
                            <th className="border border-gray-400 px-4 py-2">Setting</th>
                            <th className="border border-gray-400 px-4 py-2">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-gray-400 px-4 py-2 font-bold">IP Address</td>
                            <td className="border border-gray-400 px-4 py-2">
                                <div className="flex flex-col gap-y-2"></div>
                                <div>
                                    Use <b>127.0.0.1</b> if Deck Hopper runs on the same device as SAMMI Core.  </div>
                                <div>On mobile or if running Deck Hopper on a different device, retrieve the IP address from SAMMI Core - SAMMI Panel - Get LAN IP. </div>


                                <div>Alternatively, open Command Prompt on the SAMMI Core device, type <b>ipconfig</b>, and find the IPv4 Address of your ethernet or WiFi adapter. Ensure it's not the address of a VPN or virtual adapter like Hyper-V Virtual Ethernet Adapter. </div>
                                <RenderMediaContent src={ipconfig_settings} />
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-gray-400 px-4 py-2 font-bold">Port</td>
                            <td className="border border-gray-400 px-4 py-2">
                                The default port for SAMMI Core is <b>9470</b>. Find yours in SAMMI - Settings - Connections - Deck App Connection settings.
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-gray-400 px-4 py-2 font-bold">Password</td>
                            <td className="border border-gray-400 px-4 py-2">
                                Use the password set in SAMMI Core - Settings - Deck App Connection settings.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>

                Once you fill out connection settings, click or tap <b>Connect</b>. You should see a list of all decks created in SAMMI Core. Select a deck to enter it.
            </div>

            {/* Additional Information */}
            <div className="flex flex-col gap-y-4">
                <h2 className="text-xl font-bold">Deck Hopper Advanced extension</h2>
                <p className="mb-3">In order to use some advanced features, you will need to install the Deck Hopper Advanced Extension. This extension is free to download and use, however some features may require Deck Hopper Pro.</p>
                <div className="flex flex-col w-3/4 my-5 max-w-[550px]">
                    <iframe className="w-full h-full border-none" title="itchDownload" frameBorder="0" src="https://itch.io/embed/2655946?linkback=true&amp;border_width=0&amp;bg_color=222222&amp;fg_color=eeeeee&amp;link_color=284ed3&amp;border_color=363636"><a href="https://christinak.itch.io/deck-hopper-advanced">Deck Hopper Advanced</a></iframe>
                </div>
            </div>
        </div>
    );
};
